export class RiskPolicyGuideline {
  id: number;
  title: string;
  filename: string;
  audience: string;
  approvalDate: Date;
  approvalReviewDate: Date;
  approved: boolean;
}
